var _excluded = ["elementKey"],
  _excluded2 = ["width", "height", "imageShape", "objectFit", "objectPosition", "aspectRatio", "borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
  _excluded3 = ["border", "borderTop", "borderRight", "borderBottom", "borderLeft", "borderWidth", "borderStyle", "borderColor", "height", "background"],
  _excluded4 = ["textAlign", "width", "maxWidth", "minWidth", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { BLOCK_TEXT_WRAP_STYLE, TABLE_CELL_WRAP_STYLE } from "../../constants/defaultBlocks";
import { getTableElementStyle, getTableColumnCount, isSingleWeightFont, getColumnLayoutLabels, buildElementRenderStyle, getListMarker, getColumnBackground, hasInlineMarkdown, inlineMarkdownToHtml, resolveBlockGap, omitBlockLayoutStyles, pickBackgroundFillStyle, resolveBorderStyleProps, resolveStyleMaxWidth, getNegativeLetterSpacingPad, styleHasSpacing, hasIndividualRadius, resolveButtonPadding, splitColumnLayoutStyle, getColumnShellStyle, isColumnLayoutType, getInnerBorderOverlayStyle, getColumnLayoutGapConfig, getColumnLayoutOuterWidth, getCircularColumnBoxSize, isCircularBorderRadius, getShorthandSideLength, getColumnStyleValue, isIntrinsicColumnWidth, pickTableWrapperBorderStyle } from "../../utils/helpers";
import BlockIcon from "../BlockIcon";
import MentionAwareInput from "../MentionAwareInput";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var renderSocialIcon = function renderSocialIcon(type) {
  var style = {
    width: 18,
    height: 18,
    fill: "currentColor"
  };
  if (type === "facebook") {
    return /*#__PURE__*/_jsx("svg", {
      style: style,
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/_jsx("path", {
        d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.75z"
      })
    });
  }
  if (type === "twitter") {
    return /*#__PURE__*/_jsx("svg", {
      style: style,
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.7 0-1.37-.2-1.95-.54v.05c0 2.08 1.48 3.82 3.44 4.21-.36.1-.74.15-1.13.15-.27 0-.54-.03-.8-.08.54 1.68 2.1 2.9 3.95 2.94-1.44 1.12-3.26 1.8-5.23 1.8-.34 0-.67-.02-1-.06C2.62 21.02 4.88 22 7.28 22 14.81 22 18.9 15.77 18.9 10.37c0-.18 0-.35-.01-.53.8-.57 1.49-1.3 2.03-2.13z"
      })
    });
  }
  if (type === "linkedin") {
    return /*#__PURE__*/_jsx("svg", {
      style: style,
      viewBox: "0 0 24 24",
      children: /*#__PURE__*/_jsx("path", {
        d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.8v8.37h2.8v-4.87c0-.26.05-.53.13-.72a1.11 1.11 0 0 1 1-.76c.55 0 1 .41 1 1.17v5.18h2.8M6.5 8.37a1.37 1.37 0 1 0 0-2.75 1.37 1.37 0 0 0 0 2.75M8 18.5V10.1H5.1v8.4H8z"
      })
    });
  }
  if (type === "instagram") {
    return /*#__PURE__*/_jsxs("svg", {
      style: _objectSpread(_objectSpread({}, style), {}, {
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2
      }),
      viewBox: "0 0 24 24",
      children: [/*#__PURE__*/_jsx("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "5",
        ry: "5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
      }), /*#__PURE__*/_jsx("line", {
        x1: "17.5",
        y1: "6.5",
        x2: "17.51",
        y2: "6.5"
      })]
    });
  }
  return null;
};
var blockShellStyle = function blockShellStyle() {
  var _ref, _extra$width;
  var baseStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread(_objectSpread({}, baseStyle), extra), {}, {
    width: (_ref = (_extra$width = extra.width) !== null && _extra$width !== void 0 ? _extra$width : baseStyle.width) !== null && _ref !== void 0 ? _ref : "100%",
    maxWidth: resolveStyleMaxWidth(_objectSpread(_objectSpread({}, baseStyle), extra), "100%"),
    minWidth: 0,
    boxSizing: "border-box",
    // Keep visible so selection outline/toolbar are not clipped (unless clip-path needs it)
    overflow: baseStyle.clipPath || extra.clipPath ? "hidden" : extra.overflow || baseStyle.overflow || "visible"
  });
};
var renderBlockShell = function renderBlockShell(p, children) {
  var extraStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var innerBorderOverlay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return /*#__PURE__*/_jsxs("div", {
    onClick: p.onClick,
    style: _objectSpread({
      position: "relative"
    }, blockShellStyle(p.style, extraStyle)),
    children: [innerBorderOverlay, children]
  });
};
var renderInlineInput = function renderInlineInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    onFocusSelect = _ref2.onFocusSelect,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? "Type here..." : _ref2$placeholder,
    _ref2$isTextArea = _ref2.isTextArea,
    isTextArea = _ref2$isTextArea === void 0 ? false : _ref2$isTextArea,
    _ref2$singleLine = _ref2.singleLine,
    singleLine = _ref2$singleLine === void 0 ? false : _ref2$singleLine,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? 3 : _ref2$rows,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? "default" : _ref2$variant,
    _ref2$mentionConfig = _ref2.mentionConfig,
    mentionConfig = _ref2$mentionConfig === void 0 ? null : _ref2$mentionConfig,
    _ref2$onTextSelection = _ref2.onTextSelection,
    onTextSelection = _ref2$onTextSelection === void 0 ? null : _ref2$onTextSelection;
  return /*#__PURE__*/_jsx(MentionAwareInput, {
    value: value,
    onChange: onChange,
    onFocusSelect: onFocusSelect,
    style: style,
    placeholder: placeholder,
    isTextArea: isTextArea,
    singleLine: singleLine,
    rows: rows,
    variant: variant,
    mentionConfig: mentionConfig,
    onTextSelection: onTextSelection
  });
};
export default function CanvasBlockRenderer(_ref3) {
  var BlockList = _ref3.BlockList,
    node = _ref3.node,
    nodeFont = _ref3.nodeFont,
    nodeWeight = _ref3.nodeWeight,
    isNodeSelected = _ref3.isNodeSelected,
    p = _ref3.p,
    signBlockSide = _ref3.signBlockSide,
    editTableHeader = _ref3.editTableHeader,
    editTableCell = _ref3.editTableCell,
    editText = _ref3.editText,
    editCardTitle = _ref3.editCardTitle,
    editListItem = _ref3.editListItem,
    editTwoColumnLeft = _ref3.editTwoColumnLeft,
    editTwoColumnRight = _ref3.editTwoColumnRight,
    editThreeColumn = _ref3.editThreeColumn,
    editContentField = _ref3.editContentField,
    editAccordionItem = _ref3.editAccordionItem,
    editPricingPlan = _ref3.editPricingPlan,
    editPricingFeature = _ref3.editPricingFeature,
    editTestimonial = _ref3.editTestimonial,
    editTimelineItem = _ref3.editTimelineItem,
    onSelectBlock = _ref3.onSelectBlock,
    onSelectElement = _ref3.onSelectElement,
    selectedElement = _ref3.selectedElement,
    selected = _ref3.selected,
    dragSourceRef = _ref3.dragSourceRef,
    dragOverPos = _ref3.dragOverPos,
    isDragActive = _ref3.isDragActive,
    handleDragOverCanvas = _ref3.handleDragOverCanvas,
    handleDropCanvas = _ref3.handleDropCanvas,
    handleDragStartCanvas = _ref3.handleDragStartCanvas,
    copy = _ref3.copy,
    paste = _ref3.paste,
    _ref3$canPaste = _ref3.canPaste,
    canPaste = _ref3$canPaste === void 0 ? false : _ref3$canPaste,
    duplicate = _ref3.duplicate,
    moveBlockUp = _ref3.moveBlockUp,
    moveBlockDown = _ref3.moveBlockDown,
    moveBlockOutOfColumn = _ref3.moveBlockOutOfColumn,
    remove = _ref3.remove,
    ungroup = _ref3.ungroup,
    toggleBlockLock = _ref3.toggleBlockLock,
    moveBlockTo = _ref3.moveBlockTo,
    viewport = _ref3.viewport,
    getActiveFontFamily = _ref3.getActiveFontFamily,
    _ref3$mentionConfig = _ref3.mentionConfig,
    mentionConfig = _ref3$mentionConfig === void 0 ? null : _ref3$mentionConfig,
    _ref3$inheritTextColo = _ref3.inheritTextColor,
    inheritTextColor = _ref3$inheritTextColo === void 0 ? null : _ref3$inheritTextColo,
    _ref3$onTextSelection = _ref3.onTextSelection,
    onTextSelection = _ref3$onTextSelection === void 0 ? null : _ref3$onTextSelection;
  var focusSelect = function focusSelect(elementKey) {
    if (typeof onSelectElement === "function" && elementKey) {
      onSelectElement(node.id, elementKey);
    } else if (typeof onSelectBlock === "function") {
      onSelectBlock(node.id);
    }
  };
  var elStyle = function elStyle(elementKey) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var style = buildElementRenderStyle(node, elementKey, nodeFont, nodeWeight, extra);
    if (isNodeSelected && selectedElement === elementKey) {
      style.boxShadow = "inset 0 0 0 2px #6366f1";
    }
    return style;
  };
  var input = function input(_ref4) {
    var elementKey = _ref4.elementKey,
      props = _objectWithoutProperties(_ref4, _excluded);
    return renderInlineInput(_objectSpread({
      onFocusSelect: elementKey ? function () {
        return focusSelect(elementKey);
      } : undefined,
      mentionConfig: mentionConfig,
      onTextSelection: elementKey && typeof onTextSelection === "function" ? function (range) {
        return onTextSelection(_objectSpread(_objectSpread({}, range), {}, {
          blockId: node.id,
          elementKey: elementKey
        }));
      } : undefined
    }, props));
  };
  var renderInnerBorderOverlay = function renderInnerBorderOverlay() {
    var overlayStyle = getInnerBorderOverlayStyle(node.style);
    if (!overlayStyle) return null;
    return /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      "data-no-position-drag": true,
      style: overlayStyle
    });
  };
  var innerBorderOverlay = renderInnerBorderOverlay();
  var isNestedColumns = function isNestedColumns(content) {
    return Array.isArray(content === null || content === void 0 ? void 0 : content.columns) && content.columns.length > 0 && Array.isArray(content.columns[0]);
  };
  var blockListSharedProps = {
    selected: selected,
    selectedElement: selectedElement,
    selectBlock: onSelectBlock,
    selectElement: onSelectElement,
    dragSourceRef: dragSourceRef,
    dragOverPos: dragOverPos,
    isDragActive: isDragActive,
    handleDragOverCanvas: handleDragOverCanvas,
    handleDropCanvas: handleDropCanvas,
    handleDragStartCanvas: handleDragStartCanvas,
    copy: copy,
    paste: paste,
    canPaste: canPaste,
    duplicate: duplicate,
    moveBlockUp: moveBlockUp,
    moveBlockDown: moveBlockDown,
    moveBlockOutOfColumn: moveBlockOutOfColumn,
    remove: remove,
    ungroup: ungroup,
    toggleBlockLock: toggleBlockLock,
    moveBlockTo: moveBlockTo,
    viewport: viewport,
    signBlockSide: signBlockSide,
    getActiveFontFamily: getActiveFontFamily,
    editTableHeader: editTableHeader,
    editTableCell: editTableCell,
    editText: editText,
    editCardTitle: editCardTitle,
    editListItem: editListItem,
    editTwoColumnLeft: editTwoColumnLeft,
    editTwoColumnRight: editTwoColumnRight,
    editThreeColumn: editThreeColumn,
    editContentField: editContentField,
    editAccordionItem: editAccordionItem,
    editPricingPlan: editPricingPlan,
    editPricingFeature: editPricingFeature,
    editTestimonial: editTestimonial,
    editTimelineItem: editTimelineItem,
    mentionConfig: mentionConfig,
    onTextSelection: onTextSelection
  };
  var getColumnDropProps = function getColumnDropProps(columnIndex, blockCount) {
    return {
      onDragOver: function onDragOver(e) {
        var _e$target$closest, _e$target;
        e.preventDefault();
        var fromNestedList = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, "[data-builder-list]");
        if (fromNestedList && e.currentTarget.contains(fromNestedList)) {
          return;
        }
        e.stopPropagation();
        var list = e.currentTarget.querySelector(":scope > [data-builder-list]");
        var rect = (list || e.currentTarget).getBoundingClientRect();
        var edge = Math.max(16, Math.min(36, rect.height * 0.28));
        var index = e.clientY <= rect.top + edge ? 0 : blockCount;
        if (typeof handleDragOverCanvas === "function") {
          handleDragOverCanvas(e, node.id, columnIndex, index);
        }
      },
      onDrop: function onDrop(e) {
        var _e$target$closest2, _e$target2;
        e.preventDefault();
        var fromNestedList = (_e$target$closest2 = (_e$target2 = e.target).closest) === null || _e$target$closest2 === void 0 ? void 0 : _e$target$closest2.call(_e$target2, "[data-builder-list]");
        if (fromNestedList && e.currentTarget.contains(fromNestedList)) {
          return;
        }
        e.stopPropagation();
        var list = e.currentTarget.querySelector(":scope > [data-builder-list]");
        var rect = (list || e.currentTarget).getBoundingClientRect();
        var edge = Math.max(16, Math.min(36, rect.height * 0.28));
        var index = e.clientY <= rect.top + edge ? 0 : blockCount;
        if (typeof handleDropCanvas === "function") {
          handleDropCanvas(e, node.id, columnIndex, index);
        }
      }
    };
  };
  var getContainerDropProps = function getContainerDropProps() {
    return {
      onDragOver: function onDragOver(e) {
        e.preventDefault();
      },
      onDrop: function onDrop(e) {
        e.preventDefault();
      }
    };
  };
  var renderColumnDropZone = function renderColumnDropZone(colBlocks, columnIndex, labels) {
    var _ref5, _node$style;
    var listGap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "12px";
    var columnTextColor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var blocks = colBlocks || [];
    var isEmpty = blocks.length === 0;
    var isDropTarget = isDragActive && (dragOverPos === null || dragOverPos === void 0 ? void 0 : dragOverPos.parentId) === node.id && (dragOverPos === null || dragOverPos === void 0 ? void 0 : dragOverPos.columnIndex) === columnIndex;
    var columnBg = getColumnBackground(node.style, columnIndex);
    var hasColumnBg = Boolean(columnBg && columnBg !== "transparent" && columnBg !== "inherit" && columnBg !== "initial" && columnBg !== "rgba(0, 0, 0, 0)" && columnBg !== "rgba(0,0,0,0)" && columnBg !== "#00000000");
    var shellStyle = getColumnShellStyle(node.style, columnIndex, {
      isEmpty: isEmpty
    });
    var nestedTextColor = (_ref5 = columnTextColor !== null && columnTextColor !== void 0 ? columnTextColor : isColumnLayoutType(node.type) ? (_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.color : inheritTextColor) !== null && _ref5 !== void 0 ? _ref5 : null;
    var columnWidthValue = getColumnStyleValue(node.style, "columnWidths", columnIndex);
    var listShrinkWrap = isIntrinsicColumnWidth(columnWidthValue);
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      "data-column-zone": true,
      style: _objectSpread(_objectSpread({}, shellStyle), {}, {
        minWidth: listShrinkWrap ? "auto" : 0,
        // Keep percent column maxWidth (e.g. 64%/36%). Forcing 100% made both
        // columns flexGrow equally and look ~50/50 while preview kept the ratio.
        maxWidth: shellStyle.maxWidth || "100%",
        minHeight: shellStyle.minHeight || (isEmpty ? 120 : undefined),
        position: "relative",
        transition: "background 0.15s ease, box-shadow 0.15s ease"
      }, isEmpty ? {
        // Outline/shadow only — a real border adds width and wraps the last column.
        outline: isDropTarget ? "2px dashed #38bdf8" : hasColumnBg ? "none" : "1px dashed #94a3b8",
        outlineOffset: -1,
        boxShadow: isDropTarget ? "inset 0 0 0 1px #ffffff" : "none",
        background: isDropTarget ? "rgba(56, 189, 248, 0.22)" : columnBg || "rgba(148, 163, 184, 0.12)"
      } : isDropTarget ? {
        boxShadow: "inset 0 0 0 2px #38bdf8"
      } : null),
      onClick: function onClick(e) {
        // Empty column padding / gap → select the parent column layout, not a child
        if (e.target.closest("[data-builder-block]")) return;
        e.preventDefault();
        e.stopPropagation();
        if (typeof onSelectBlock === "function") {
          onSelectBlock(node.id);
        }
      }
    }, getColumnDropProps(columnIndex, blocks.length)), {}, {
      children: [isEmpty && !hasColumnBg && /*#__PURE__*/_jsxs("div", {
        style: {
          color: "#94a3b8",
          fontSize: 14,
          lineHeight: 1.45,
          pointerEvents: "none",
          userSelect: "none",
          marginBottom: 4
        },
        children: [labels[columnIndex], /*#__PURE__*/_jsx("div", {
          style: {
            fontSize: 12,
            marginTop: 4,
            opacity: 0.85
          },
          children: "Drop blocks here"
        })]
      }), /*#__PURE__*/_jsx(BlockList, _objectSpread({
        blocks: blocks,
        parentId: node.id,
        columnIndex: columnIndex,
        listGap: listGap,
        listAlignItems: listShrinkWrap ? "flex-start" : shellStyle.alignItems || "stretch",
        listJustifyContent: shellStyle.justifyContent || "flex-start",
        listShrinkWrap: listShrinkWrap,
        endDropSpace: 20,
        inheritTextColor: nestedTextColor
      }, blockListSharedProps))]
    }), columnIndex);
  };
  if (node.type === "heading") {
    var _node$content$text, _node$content, _p$style, _p$style2, _p$style3;
    var Tag = node.content.tag || "h1";
    var text = (_node$content$text = (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.text) !== null && _node$content$text !== void 0 ? _node$content$text : "";
    var showMarkdownPreview = hasInlineMarkdown(text) && selectedElement !== "text";
    var textElStyle = elStyle("text");
    var textPartStyle = omitBlockLayoutStyles(textElStyle);
    var headingFill = pickBackgroundFillStyle(_objectSpread(_objectSpread({}, p.style || {}), textElStyle));
    var letterSpacing = textPartStyle.letterSpacing || ((_p$style = p.style) === null || _p$style === void 0 ? void 0 : _p$style.letterSpacing);
    var lsPad = getNegativeLetterSpacingPad(letterSpacing);
    var lsPadStyle = lsPad > 0 ? {
      paddingLeft: lsPad,
      paddingRight: lsPad
    } : {};
    // fit-content column shells set width on p.style — inputs must hug text too
    var hugContent = isIntrinsicColumnWidth((_p$style2 = p.style) === null || _p$style2 === void 0 ? void 0 : _p$style2.width) || ((_p$style3 = p.style) === null || _p$style3 === void 0 ? void 0 : _p$style3.width) === "auto";
    return renderBlockShell(p, /*#__PURE__*/_jsx(Tag, {
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        margin: 0,
        padding: 0,
        border: "none",
        // Reset global h1–h6 CSS, then apply block/element fill so the tag itself is painted
        background: "transparent",
        fontFamily: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        color: "inherit",
        lineHeight: "inherit",
        letterSpacing: letterSpacing || "inherit",
        textAlign: "inherit",
        textTransform: "inherit",
        width: hugContent ? "fit-content" : "100%",
        maxWidth: "100%",
        minWidth: hugContent ? "auto" : 0,
        overflow: "visible",
        display: hugContent ? "inline-block" : "block"
      }, textPartStyle), headingFill), lsPadStyle), BLOCK_TEXT_WRAP_STYLE),
      children: showMarkdownPreview ? /*#__PURE__*/_jsx("div", {
        onClick: function onClick(e) {
          e.stopPropagation();
          if (typeof onSelectElement === "function") onSelectElement(node.id, "text");
        },
        style: {
          cursor: "text",
          minHeight: "1em",
          letterSpacing: letterSpacing || "inherit"
        },
        dangerouslySetInnerHTML: {
          __html: inlineMarkdownToHtml(text)
        }
      }) : input({
        elementKey: "text",
        value: text,
        onChange: function onChange(v) {
          if (typeof editText === "function") editText(v, node.id);
        },
        placeholder: "Heading goes here...",
        singleLine: hugContent,
        style: letterSpacing ? {
          letterSpacing: letterSpacing
        } : undefined
      })
    }), _objectSpread({
      fontFamily: nodeFont,
      fontWeight: nodeWeight
    }, headingFill), innerBorderOverlay);
  }
  if (node.type === "text") {
    var _p$style4, _p$style5, _p$style6;
    var _text = node.content.text || "";
    var _showMarkdownPreview = hasInlineMarkdown(_text) && selectedElement !== "text";
    var _textElStyle = elStyle("text");
    var _textPartStyle = omitBlockLayoutStyles(_textElStyle);
    var textFill = pickBackgroundFillStyle(_objectSpread(_objectSpread({}, p.style || {}), _textElStyle));
    var _letterSpacing = _textPartStyle.letterSpacing || ((_p$style4 = p.style) === null || _p$style4 === void 0 ? void 0 : _p$style4.letterSpacing);
    var _lsPad = getNegativeLetterSpacingPad(_letterSpacing);
    var _lsPadStyle = _lsPad > 0 ? {
      paddingLeft: _lsPad,
      paddingRight: _lsPad
    } : {};
    var _hugContent = isIntrinsicColumnWidth((_p$style5 = p.style) === null || _p$style5 === void 0 ? void 0 : _p$style5.width) || ((_p$style6 = p.style) === null || _p$style6 === void 0 ? void 0 : _p$style6.width) === "auto";
    return renderBlockShell(p, _showMarkdownPreview ? /*#__PURE__*/_jsx("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
        if (typeof onSelectElement === "function") onSelectElement(node.id, "text");
      },
      style: _objectSpread(_objectSpread(_objectSpread({
        cursor: "text",
        whiteSpace: "pre-wrap",
        fontFamily: nodeFont,
        minHeight: "1.5em",
        letterSpacing: _letterSpacing || "inherit"
      }, _textPartStyle), textFill), _lsPadStyle),
      dangerouslySetInnerHTML: {
        __html: inlineMarkdownToHtml(_text)
      }
    }) : input({
      elementKey: "text",
      value: _text,
      onChange: function onChange(v) {
        if (typeof editText === "function") editText(v, node.id);
      },
      isTextArea: !_hugContent,
      singleLine: _hugContent,
      rows: 1,
      placeholder: "Text paragraph goes here...",
      style: _letterSpacing ? {
        letterSpacing: _letterSpacing
      } : undefined
    }), _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      whiteSpace: "pre-wrap",
      fontFamily: nodeFont,
      letterSpacing: _letterSpacing
    }, _hugContent ? {
      width: "fit-content",
      display: "inline-block"
    } : {}), _textPartStyle), textFill), _lsPadStyle), innerBorderOverlay);
  }
  if (node.type === "button") {
    var _node$style2, _node$style3, _p$style7, _p$style8;
    var buttonPadding = resolveButtonPadding(p.style);
    // Honor style.width (e.g. 100% full-bleed CTAs). Hardcoding auto made builder
    // buttons shrink-wrap while preview/export used width:100%.
    var buttonWidth = (_node$style2 = node.style) !== null && _node$style2 !== void 0 && _node$style2.width && node.style.width !== "auto" ? node.style.width : "auto";
    var isFullWidth = buttonWidth === "100%" || buttonWidth === "100";
    return /*#__PURE__*/_jsx("div", {
      onClick: p.onClick,
      style: {
        textAlign: ((_node$style3 = node.style) === null || _node$style3 === void 0 ? void 0 : _node$style3.textAlign) || "left",
        maxWidth: "100%",
        minWidth: 0,
        width: "100%"
      },
      children: /*#__PURE__*/_jsx("div", {
        style: blockShellStyle(p.style, _objectSpread(_objectSpread({
          cursor: "text",
          border: (_p$style7 = p.style) !== null && _p$style7 !== void 0 && _p$style7.borderWidth && (_p$style8 = p.style) !== null && _p$style8 !== void 0 && _p$style8.borderStyle ? "".concat(p.style.borderWidth, " ").concat(p.style.borderStyle, " ").concat(p.style.borderColor || "#cbd5e1") : "none",
          display: isFullWidth ? "flex" : "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: buttonWidth,
          maxWidth: "100%",
          textAlign: "center",
          fontFamily: nodeFont,
          fontWeight: nodeWeight,
          verticalAlign: "top",
          boxSizing: "border-box"
        }, buttonPadding ? {
          padding: buttonPadding
        } : {}), elStyle("text"))),
        children: input({
          elementKey: "text",
          variant: "onColor",
          singleLine: true,
          value: node.content.text,
          onChange: function onChange(v) {
            if (typeof editText === "function") editText(v, node.id);
          },
          placeholder: "Button text..."
        })
      })
    });
  }
  if (node.type === "image") {
    var _node$style4, _node$style5, _node$style6, _node$style7, _node$style8, _node$style9, _node$style10, _node$style11, _node$style12, _node$style13, _node$style14;
    var isCircle = ((_node$style4 = node.style) === null || _node$style4 === void 0 ? void 0 : _node$style4.imageShape) === "circle";
    var _ref6 = p.style || {},
      _styleWidth = _ref6.width,
      height = _ref6.height,
      _imageShape = _ref6.imageShape,
      objectFit = _ref6.objectFit,
      objectPosition = _ref6.objectPosition,
      _aspectRatio = _ref6.aspectRatio,
      _borderRadius = _ref6.borderRadius,
      _tl = _ref6.borderTopLeftRadius,
      _tr = _ref6.borderTopRightRadius,
      _br = _ref6.borderBottomRightRadius,
      _bl = _ref6.borderBottomLeftRadius,
      containerStyle = _objectWithoutProperties(_ref6, _excluded2);
    // Source of truth: node.style.width once (preview/PDF apply % once too)
    var imageWidth = ((_node$style5 = node.style) === null || _node$style5 === void 0 ? void 0 : _node$style5.width) || "100%";
    var radiusStyle = isCircle ? {
      borderRadius: "50%"
    } : _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (_node$style6 = node.style) !== null && _node$style6 !== void 0 && _node$style6.borderRadius ? {
      borderRadius: node.style.borderRadius
    } : {}), (_node$style7 = node.style) !== null && _node$style7 !== void 0 && _node$style7.borderTopLeftRadius ? {
      borderTopLeftRadius: node.style.borderTopLeftRadius
    } : {}), (_node$style8 = node.style) !== null && _node$style8 !== void 0 && _node$style8.borderTopRightRadius ? {
      borderTopRightRadius: node.style.borderTopRightRadius
    } : {}), (_node$style9 = node.style) !== null && _node$style9 !== void 0 && _node$style9.borderBottomRightRadius ? {
      borderBottomRightRadius: node.style.borderBottomRightRadius
    } : {}), (_node$style10 = node.style) !== null && _node$style10 !== void 0 && _node$style10.borderBottomLeftRadius ? {
      borderBottomLeftRadius: node.style.borderBottomLeftRadius
    } : {});
    var hasRadius = isCircle || Object.keys(radiusStyle).length > 0;
    var imageAlign = ((_node$style11 = node.style) === null || _node$style11 === void 0 ? void 0 : _node$style11.textAlign) || "left";
    var isFullBleedImage = !imageWidth || imageWidth === "100%" || imageWidth === "100";
    var imageMargins = !isFullBleedImage && imageAlign === "center" ? {
      marginLeft: "auto",
      marginRight: "auto"
    } : !isFullBleedImage && imageAlign === "right" ? {
      marginLeft: "auto",
      marginRight: 0
    } : {};
    return /*#__PURE__*/_jsx("div", {
      onClick: p.onClick,
      style: {
        textAlign: imageAlign,
        width: "100%"
      },
      children: /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, containerStyle), {}, {
          // block avoids inline-block baseline gap that lifts icons (heart divider) above adjacent lines
          display: "block",
          width: imageWidth,
          maxWidth: resolveStyleMaxWidth(node.style || p.style, "100%"),
          boxSizing: "border-box",
          lineHeight: 0,
          fontSize: 0
        }, imageMargins), hasRadius ? {
          overflow: "hidden"
        } : {}), radiusStyle), isCircle ? {
          aspectRatio: "1 / 1",
          height: "auto"
        } : {}),
        children: /*#__PURE__*/_jsx("img", {
          src: node.content.src,
          alt: node.content.alt || "Image",
          style: _objectSpread({
            display: "block",
            width: "100%",
            height: isCircle ? "100%" : height || ((_node$style12 = node.style) === null || _node$style12 === void 0 ? void 0 : _node$style12.height) || "auto",
            objectFit: objectFit || ((_node$style13 = node.style) === null || _node$style13 === void 0 ? void 0 : _node$style13.objectFit) || (isCircle ? "cover" : "contain"),
            objectPosition: objectPosition || ((_node$style14 = node.style) === null || _node$style14 === void 0 ? void 0 : _node$style14.objectPosition) || "50% 50%",
            pointerEvents: "none"
          }, radiusStyle)
        })
      })
    });
  }
  if (node.type === "card") {
    var _node$style15, _node$style16, _node$style17;
    return renderBlockShell(p, /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h2", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "1.25rem"
        }, elStyle("title")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "title",
          value: node.content.title,
          onChange: function onChange(v) {
            if (typeof editCardTitle === "function") editCardTitle(v, node.id);
          },
          placeholder: "Card Title"
        })
      }), /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          opacity: 0.8,
          whiteSpace: "pre-wrap"
        }, elStyle("text")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "text",
          value: node.content.text,
          onChange: function onChange(v) {
            if (typeof editText === "function") editText(v, node.id);
          },
          isTextArea: true,
          rows: 3,
          placeholder: "Card description text..."
        })
      })]
    }), {
      display: "flex",
      flexDirection: "column",
      gap: resolveBlockGap(p.style, "8px"),
      border: "".concat(((_node$style15 = node.style) === null || _node$style15 === void 0 ? void 0 : _node$style15.borderWidth) || "1px", " ").concat(((_node$style16 = node.style) === null || _node$style16 === void 0 ? void 0 : _node$style16.borderStyle) || "solid", " ").concat(((_node$style17 = node.style) === null || _node$style17 === void 0 ? void 0 : _node$style17.borderColor) || "#e2e8f0"),
      fontFamily: nodeFont
    }, innerBorderOverlay);
  }
  if (node.type === "page-break") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      title: "PDF page break",
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        height: 1,
        borderTop: "2px dashed #94a3b8",
        position: "relative",
        overflow: "visible"
      }),
      children: /*#__PURE__*/_jsx("span", {
        style: {
          position: "absolute",
          left: "50%",
          top: -10,
          transform: "translateX(-50%)",
          background: "#ffffff",
          color: "#64748b",
          fontSize: 10,
          padding: "1px 6px",
          whiteSpace: "nowrap"
        },
        children: "PAGE BREAK"
      })
    }));
  }
  if (node.type === "divider") {
    var _node$style18, _node$style19, _node$style20, _p$style9;
    var lineWidth = !((_node$style18 = node.style) !== null && _node$style18 !== void 0 && _node$style18.borderWidth) || node.style.borderWidth === "0px" ? "1px" : node.style.borderWidth;
    var lineStyle = !((_node$style19 = node.style) !== null && _node$style19 !== void 0 && _node$style19.borderStyle) || node.style.borderStyle === "none" ? "solid" : node.style.borderStyle;
    var lineColor = ((_node$style20 = node.style) === null || _node$style20 === void 0 ? void 0 : _node$style20.borderColor) || "#1C252E";

    // Match preview/PDF: use a div, not <hr>. Global Bootstrap `hr { border-top: rgba(0,0,0,.1) }`
    // and default margins make canvas lines look lighter/misaligned vs export.
    var _ref7 = p.style || {},
      _b = _ref7.border,
      _bt = _ref7.borderTop,
      _br2 = _ref7.borderRight,
      _bb = _ref7.borderBottom,
      _bl2 = _ref7.borderLeft,
      _bw = _ref7.borderWidth,
      _bs = _ref7.borderStyle,
      _bc = _ref7.borderColor,
      _h = _ref7.height,
      _bg = _ref7.background,
      dividerLayoutStyle = _objectWithoutProperties(_ref7, _excluded3);
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      role: "separator",
      style: _objectSpread(_objectSpread({}, dividerLayoutStyle), {}, {
        border: "none",
        borderTopWidth: lineWidth,
        borderTopStyle: lineStyle,
        borderTopColor: lineColor,
        width: ((_p$style9 = p.style) === null || _p$style9 === void 0 ? void 0 : _p$style9.width) || "100%",
        // Do not force height/maxHeight 0 — that can clip border-top with border-box
        background: "transparent",
        boxSizing: "border-box",
        fontSize: 0,
        lineHeight: 0,
        display: "block",
        alignSelf: "stretch",
        overflow: "visible"
      })
    }));
  }
  if (node.type === "html") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      onClick: function onClick(e) {
        // Keep editor from navigating when HTML contains links
        if (e.target.closest("a[href]")) {
          e.preventDefault();
        }
        if (typeof p.onClick === "function") {
          p.onClick(e);
        }
      },
      dangerouslySetInnerHTML: {
        __html: node.content.code
      }
    }));
  }
  if (node.type === "list") {
    var listStyle = node.content.listStyle || "check";
    var listGap = resolveBlockGap(p.style, "6px");
    return /*#__PURE__*/_jsx("ul", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        listStyleType: "none",
        display: "flex",
        flexDirection: "column",
        gap: listGap,
        fontFamily: nodeFont
      }),
      children: (node.content.items || []).map(function (item, i) {
        var _node$style21, _node$style22;
        return /*#__PURE__*/_jsxs("li", {
          style: {
            padding: 0,
            margin: 0,
            background: "transparent",
            border: "none",
            borderRadius: 0,
            display: "flex",
            alignItems: "flex-start",
            gap: 8,
            fontFamily: "inherit",
            fontSize: "inherit",
            color: "inherit",
            fontWeight: "inherit"
          },
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              color: listStyle === "check" ? ((_node$style21 = node.style) === null || _node$style21 === void 0 ? void 0 : _node$style21.markerColor) || ((_node$style22 = node.style) === null || _node$style22 === void 0 ? void 0 : _node$style22.color) || "#10b981" : "inherit",
              fontWeight: 700,
              flexShrink: 0,
              minWidth: listStyle === "check" || listStyle === "bullet" ? 0 : 18
            },
            children: getListMarker(listStyle, i)
          }), /*#__PURE__*/_jsx("span", {
            style: _objectSpread(_objectSpread({
              minWidth: 0,
              flex: 1
            }, omitBlockLayoutStyles(elStyle("item_".concat(i)))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "item_".concat(i),
              value: item,
              onChange: function onChange(v) {
                if (typeof editListItem === "function") editListItem(i, v);
              },
              placeholder: "List item..."
            })
          })]
        }, i);
      })
    }));
  }
  if (node.type === "spacer") {
    var _node$style23;
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        height: ((_node$style23 = node.style) === null || _node$style23 === void 0 ? void 0 : _node$style23.height) || "40px"
      })
    }));
  }
  if (node.type === "social") {
    var _node$style24, _node$style25;
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        justifyContent: ((_node$style24 = node.style) === null || _node$style24 === void 0 ? void 0 : _node$style24.textAlign) === "left" ? "flex-start" : ((_node$style25 = node.style) === null || _node$style25 === void 0 ? void 0 : _node$style25.textAlign) === "right" ? "flex-end" : "center",
        gap: resolveBlockGap(p.style, "14px")
      }, styleHasSpacing(p.style, "padding") ? {} : {
        padding: "10px 0"
      }),
      children: ["facebook", "twitter", "linkedin", "instagram"].map(function (net) {
        var _node$style26;
        return node.content[net] ? /*#__PURE__*/_jsx("a", {
          href: node.content[net],
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: function onClick(e) {
            return e.preventDefault();
          },
          style: {
            color: ((_node$style26 = node.style) === null || _node$style26 === void 0 ? void 0 : _node$style26.color) || "#475569",
            lineHeight: 0,
            cursor: "default"
          },
          children: renderSocialIcon(net)
        }, net) : null;
      })
    }));
  }
  if (node.type === "table") {
    var _node$style27, _node$style28, _node$style29, _node$style30, _node$style31, _node$style32, _node$style33, _node$style34, _node$style35, _node$style36, _node$style38, _node$style39, _node$style40, _node$style41, _node$style42;
    var tableBorderStyle = ((_node$style27 = node.style) === null || _node$style27 === void 0 ? void 0 : _node$style27.tableBorderStyle) || "solid";
    var tableBorderWidth = ((_node$style28 = node.style) === null || _node$style28 === void 0 ? void 0 : _node$style28.tableBorderWidth) !== undefined ? node.style.tableBorderWidth : "1px";
    var tableBorderColor = ((_node$style29 = node.style) === null || _node$style29 === void 0 ? void 0 : _node$style29.tableBorderColor) || "#e2e8f0";
    var topBorderW = getShorthandSideLength(tableBorderWidth, "Top", 1, "px").value;
    var rightBorderW = getShorthandSideLength(tableBorderWidth, "Right", 1, "px").value;
    var bottomBorderW = getShorthandSideLength(tableBorderWidth, "Bottom", 1, "px").value;
    var leftBorderW = getShorthandSideLength(tableBorderWidth, "Left", 1, "px").value;
    var isNoneStyle = tableBorderStyle === "none";
    var cellBorderTop = isNoneStyle || topBorderW <= 0 ? "none" : "".concat(topBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
    var cellBorderRight = isNoneStyle || rightBorderW <= 0 ? "none" : "".concat(rightBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
    var cellBorderBottom = isNoneStyle || bottomBorderW <= 0 ? "none" : "".concat(bottomBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
    var cellBorderLeft = isNoneStyle || leftBorderW <= 0 ? "none" : "".concat(leftBorderW, "px ").concat(tableBorderStyle, " ").concat(tableBorderColor);
    var headerBg = ((_node$style30 = node.style) === null || _node$style30 === void 0 ? void 0 : _node$style30.headerBackground) || "#f8fafc";
    var headerColor = ((_node$style31 = node.style) === null || _node$style31 === void 0 ? void 0 : _node$style31.headerColor) || "inherit";
    var rowBg = ((_node$style32 = node.style) === null || _node$style32 === void 0 ? void 0 : _node$style32.rowBackground) || "transparent";
    var stripedRows = Boolean((_node$style33 = node.style) === null || _node$style33 === void 0 ? void 0 : _node$style33.stripedRows);
    var stripedRowBg = ((_node$style34 = node.style) === null || _node$style34 === void 0 ? void 0 : _node$style34.stripedRowBackground) || "#f8fafc";
    var cellPadding = ((_node$style35 = node.style) === null || _node$style35 === void 0 ? void 0 : _node$style35.cellPadding) || "10px";
    return /*#__PURE__*/_jsx("div", {
      style: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box"
      },
      children: /*#__PURE__*/_jsx("div", {
        onClick: p.onClick,
        style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          overflowX: "auto",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          WebkitOverflowScrolling: "touch",
          cursor: "pointer",
          boxSizing: "border-box",
          fontFamily: nodeFont,
          fontWeight: nodeWeight
        }, (_node$style36 = node.style) !== null && _node$style36 !== void 0 && _node$style36.color ? {
          color: node.style.color
        } : {}), styleHasSpacing(node.style, "padding") ? Object.fromEntries(["padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].filter(function (k) {
          var _node$style37;
          return ((_node$style37 = node.style) === null || _node$style37 === void 0 ? void 0 : _node$style37[k]) !== undefined;
        }).map(function (k) {
          return [k, node.style[k]];
        })) : {}), ((_node$style38 = node.style) === null || _node$style38 === void 0 ? void 0 : _node$style38.opacity) !== undefined ? {
          opacity: node.style.opacity
        } : {}), (_node$style39 = node.style) !== null && _node$style39 !== void 0 && _node$style39.background ? {
          background: node.style.background
        } : {}), (_node$style40 = node.style) !== null && _node$style40 !== void 0 && _node$style40.backgroundColor ? {
          backgroundColor: node.style.backgroundColor
        } : {}), pickTableWrapperBorderStyle(node.style || {})), (_node$style41 = node.style) !== null && _node$style41 !== void 0 && _node$style41.borderRadius ? {
          borderRadius: node.style.borderRadius
        } : {}),
        children: /*#__PURE__*/_jsxs("table", {
          style: getTableElementStyle(getTableColumnCount(node.content), _objectSpread({
            fontFamily: nodeFont
          }, (_node$style42 = node.style) !== null && _node$style42 !== void 0 && _node$style42.color ? {
            color: node.style.color
          } : {})),
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsx("tr", {
              children: (node.content.headers || []).map(function (th, i) {
                return /*#__PURE__*/_jsx("th", {
                  style: _objectSpread(_objectSpread({
                    borderTop: cellBorderTop,
                    borderRight: cellBorderRight,
                    borderBottom: cellBorderBottom,
                    borderLeft: cellBorderLeft,
                    padding: cellPadding,
                    background: headerBg,
                    textAlign: "left",
                    fontFamily: nodeFont,
                    fontWeight: nodeWeight,
                    color: headerColor
                  }, elStyle("header_".concat(i))), TABLE_CELL_WRAP_STYLE),
                  children: input({
                    elementKey: "header_".concat(i),
                    value: th,
                    onChange: function onChange(v) {
                      if (typeof editTableHeader === "function") editTableHeader(i, v);
                    },
                    placeholder: "Header"
                  })
                }, i);
              })
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: (node.content.rows || []).map(function (row, rI) {
              var totalCols = getTableColumnCount(node.content);
              var cells = Array.from({
                length: totalCols
              }, function (_, cI) {
                return row[cI] || "";
              });
              var currentRowBg = stripedRows && rI % 2 === 1 ? stripedRowBg : rowBg;
              return /*#__PURE__*/_jsx("tr", {
                children: cells.map(function (td, cI) {
                  return /*#__PURE__*/_jsx("td", {
                    style: _objectSpread(_objectSpread({
                      borderTop: cellBorderTop,
                      borderRight: cellBorderRight,
                      borderBottom: cellBorderBottom,
                      borderLeft: cellBorderLeft,
                      padding: cellPadding,
                      background: currentRowBg,
                      fontFamily: nodeFont,
                      verticalAlign: "top",
                      color: "inherit"
                    }, elStyle("cell_".concat(rI, "_").concat(cI))), TABLE_CELL_WRAP_STYLE),
                    children: input({
                      elementKey: "cell_".concat(rI, "_").concat(cI),
                      value: td,
                      onChange: function onChange(v) {
                        if (typeof editTableCell === "function") editTableCell(rI, cI, v);
                      },
                      placeholder: "Cell"
                    })
                  }, cI);
                })
              }, rI);
            })
          })]
        })
      })
    });
  }
  if (isColumnLayoutType(node.type)) {
    var _node$style43;
    var _splitColumnLayoutSty = splitColumnLayoutStyle(p.style || {}),
      colLayoutStyle = _splitColumnLayoutSty.outerStyle;
    var nestedCols = isNestedColumns(node.content) ? node.content.columns || [] : [];
    var _getColumnLayoutGapCo = getColumnLayoutGapConfig(node.type, node.style, nestedCols.length || (node.type === "one-column" ? 1 : node.type === "two-column" ? 2 : 3)),
      isSingleColumn = _getColumnLayoutGapCo.isSingleColumn,
      columnGap = _getColumnLayoutGapCo.columnGap,
      stackGap = _getColumnLayoutGapCo.stackGap;
    var outerWidth = getColumnLayoutOuterWidth(node.style, isSingleColumn);
    // Icon-badge pattern: one-column + borderRadius 50% + fixed 50×50 (preview circle).
    // Force a square clipped box — otherwise builder stretches width and 50% looks like a pill.
    var circleBox = isSingleColumn ? getCircularColumnBoxSize(node.style) : "";
    var colOuterStyle = _objectSpread(_objectSpread({}, colLayoutStyle), {}, {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      gap: columnGap,
      alignItems: colLayoutStyle.alignItems || "stretch",
      justifyContent: colLayoutStyle.justifyContent || "flex-start",
      width: circleBox || outerWidth,
      maxWidth: "100%",
      minWidth: circleBox || 0,
      fontFamily: nodeFont,
      overflow: circleBox || isCircularBorderRadius(node.style) || (_node$style43 = node.style) !== null && _node$style43 !== void 0 && _node$style43.clipPath ? "hidden" : "visible",
      boxSizing: "border-box"
    }, circleBox ? {
      height: circleBox,
      minHeight: circleBox,
      maxHeight: circleBox,
      maxWidth: circleBox,
      aspectRatio: "1 / 1",
      flexShrink: 0,
      alignSelf: "center"
    } : {});
    if (isNestedColumns(node.content) && BlockList) {
      var cols = nestedCols;
      var labels = getColumnLayoutLabels(cols.length);
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
        onClick: function onClick(e) {
          // Only select column layout when click is not on a nested child block
          if (e.target.closest("[data-builder-block]")) return;
          if (typeof p.onClick === "function") p.onClick(e);
        },
        style: _objectSpread(_objectSpread({}, colOuterStyle), {}, {
          position: "relative"
        })
      }, getContainerDropProps()), {}, {
        children: [innerBorderOverlay, cols.map(function (colBlocks, idx) {
          return renderColumnDropZone(colBlocks, idx, labels, stackGap);
        })]
      }));
    }
    if (node.type === "one-column") {
      var _node$content$col;
      var col1Bg = getColumnBackground(node.style, 0);
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
        style: _objectSpread(_objectSpread({}, colOuterStyle), {}, {
          position: "relative"
        }),
        children: [innerBorderOverlay, /*#__PURE__*/_jsx("div", {
          style: _objectSpread(_objectSpread(_objectSpread({}, getColumnShellStyle(node.style, 0)), {}, {
            whiteSpace: "pre-wrap"
          }, elStyle("col1")), BLOCK_TEXT_WRAP_STYLE),
          children: input({
            elementKey: "col1",
            value: (_node$content$col = node.content.col1) !== null && _node$content$col !== void 0 ? _node$content$col : col1Bg ? "" : "Column Content",
            onChange: function onChange(v) {
              if (typeof editThreeColumn === "function") editThreeColumn("col1", v);
            },
            isTextArea: true,
            rows: 1,
            placeholder: col1Bg ? "" : "Column Content"
          })
        })]
      }));
    }
    if (node.type === "two-column") {
      var _node$content$leftTex, _node$content$rightTe;
      var leftBg = getColumnBackground(node.style, 0);
      var rightBg = getColumnBackground(node.style, 1);
      return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
        style: _objectSpread(_objectSpread({}, colOuterStyle), {}, {
          position: "relative"
        }),
        children: [innerBorderOverlay, /*#__PURE__*/_jsx("div", {
          style: _objectSpread(_objectSpread(_objectSpread({}, getColumnShellStyle(node.style, 0)), {}, {
            whiteSpace: "pre-wrap"
          }, elStyle("leftText")), BLOCK_TEXT_WRAP_STYLE),
          children: input({
            elementKey: "leftText",
            value: (_node$content$leftTex = node.content.leftText) !== null && _node$content$leftTex !== void 0 ? _node$content$leftTex : leftBg ? "" : "Left Column Content",
            onChange: function onChange(v) {
              if (typeof editTwoColumnLeft === "function") editTwoColumnLeft(v);
            },
            isTextArea: true,
            rows: 1,
            placeholder: leftBg ? "" : "Left Column Content"
          })
        }), /*#__PURE__*/_jsx("div", {
          style: _objectSpread(_objectSpread(_objectSpread({}, getColumnShellStyle(node.style, 1)), {}, {
            whiteSpace: "pre-wrap"
          }, elStyle("rightText")), BLOCK_TEXT_WRAP_STYLE),
          children: input({
            elementKey: "rightText",
            value: (_node$content$rightTe = node.content.rightText) !== null && _node$content$rightTe !== void 0 ? _node$content$rightTe : rightBg ? "" : "Right Column Content",
            onChange: function onChange(v) {
              if (typeof editTwoColumnRight === "function") editTwoColumnRight(v);
            },
            isTextArea: true,
            rows: 1,
            placeholder: rightBg ? "" : "Right Column Content"
          })
        })]
      }));
    }
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, colOuterStyle), {}, {
        position: "relative"
      }),
      children: [innerBorderOverlay, ["col1", "col2", "col3"].map(function (colKey, idx) {
        var _node$content$colKey;
        var colBg = getColumnBackground(node.style, idx);
        return /*#__PURE__*/_jsx("div", {
          style: _objectSpread(_objectSpread(_objectSpread({}, getColumnShellStyle(node.style, idx)), {}, {
            whiteSpace: "pre-wrap"
          }, elStyle(colKey)), BLOCK_TEXT_WRAP_STYLE),
          children: input({
            elementKey: colKey,
            value: (_node$content$colKey = node.content[colKey]) !== null && _node$content$colKey !== void 0 ? _node$content$colKey : colBg ? "" : "Column ".concat(idx + 1, " Content"),
            onChange: function onChange(v) {
              if (typeof editThreeColumn === "function") editThreeColumn(colKey, v);
            },
            isTextArea: true,
            rows: 1,
            placeholder: colBg ? "" : "Column ".concat(idx + 1, " Content")
          })
        }, colKey);
      })]
    }));
  }
  if (node.type === "group") {
    var _node$content2;
    var groupedBlocks = ((_node$content2 = node.content) === null || _node$content2 === void 0 || (_node$content2 = _node$content2.columns) === null || _node$content2 === void 0 ? void 0 : _node$content2[0]) || [];
    var isEmptyGroup = !groupedBlocks.length;
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      onClick: function onClick(e) {
        if (e.target.closest("[data-builder-block]")) return;
        if (typeof p.onClick === "function") p.onClick(e);
      },
      style: _objectSpread(_objectSpread({}, resolveBorderStyleProps(p.style)), {}, {
        position: "relative",
        minHeight: isEmptyGroup && isNodeSelected ? 56 : undefined,
        fontFamily: nodeFont,
        boxSizing: "border-box"
      })
    }, getContainerDropProps()), {}, {
      children: [innerBorderOverlay, renderColumnDropZone(groupedBlocks, 0, ["GROUP — DROP BLOCKS HERE"], resolveBlockGap(p.style, "12px"), inheritTextColor)]
    }));
  }
  if (node.type === "quote") {
    var _node$style44;
    return /*#__PURE__*/_jsxs("blockquote", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        gap: resolveBlockGap(p.style, "12px"),
        // Reset browser blockquote margin; real margin is on the outer selection wrapper
        margin: 0,
        borderLeft: ((_node$style44 = node.style) === null || _node$style44 === void 0 ? void 0 : _node$style44.borderLeft) || "4px solid #101828",
        fontFamily: nodeFont
      }),
      children: [/*#__PURE__*/_jsxs("p", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "1.15rem",
          fontStyle: isSingleWeightFont(nodeFont) ? "normal" : "italic",
          lineHeight: 1.6
        }, elStyle("text")), BLOCK_TEXT_WRAP_STYLE),
        children: ["\u201C", input({
          elementKey: "text",
          value: node.content.text,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("text", v);
          },
          placeholder: "Quote text..."
        }), "\u201D"]
      }), /*#__PURE__*/_jsxs("footer", {
        style: _objectSpread(_objectSpread({
          fontSize: "0.9rem",
          opacity: 0.7
        }, elStyle("author")), BLOCK_TEXT_WRAP_STYLE),
        children: [/*#__PURE__*/_jsx("span", {
          style: _objectSpread({
            fontWeight: nodeWeight
          }, elStyle("author")),
          children: input({
            elementKey: "author",
            value: node.content.author,
            onChange: function onChange(v) {
              if (typeof editContentField === "function") editContentField("author", v);
            },
            placeholder: "Author name",
            style: {
              display: "inline-block",
              width: "auto",
              minWidth: "100px"
            }
          })
        }), " \xB7 ", input({
          elementKey: "role",
          value: node.content.role,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("role", v);
          },
          placeholder: "Author role",
          style: {
            display: "inline-block",
            width: "auto",
            minWidth: "100px"
          }
        })]
      })]
    }));
  }
  if (node.type === "icon") {
    var _node$style45, _node$style46, _node$style47;
    var align = ((_node$style45 = node.style) === null || _node$style45 === void 0 ? void 0 : _node$style45.textAlign) || "center";
    var _ref8 = p.style || {},
      _textAlign = _ref8.textAlign,
      _width = _ref8.width,
      _maxWidth = _ref8.maxWidth,
      _minWidth = _ref8.minWidth,
      _margin = _ref8.margin,
      _mt = _ref8.marginTop,
      _mr = _ref8.marginRight,
      _mb = _ref8.marginBottom,
      _ml = _ref8.marginLeft,
      chromeStyle = _objectWithoutProperties(_ref8, _excluded4);
    var explicitWidth = (_node$style46 = node.style) !== null && _node$style46 !== void 0 && _node$style46.width && node.style.width !== "auto" && node.style.width !== "100%" ? node.style.width : undefined;
    var _hasRadius = !!((_node$style47 = node.style) !== null && _node$style47 !== void 0 && _node$style47.borderRadius || hasIndividualRadius(node.style));
    return /*#__PURE__*/_jsx("div", {
      onClick: p.onClick,
      style: {
        textAlign: align,
        width: "100%",
        maxWidth: resolveStyleMaxWidth(node.style || p.style, "100%"),
        boxSizing: "border-box"
      },
      children: /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({}, chromeStyle), {}, {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          verticalAlign: "middle",
          lineHeight: 1,
          width: explicitWidth || "auto",
          height: explicitWidth && _hasRadius ? explicitWidth : chromeStyle.height,
          maxWidth: "100%"
        }, _hasRadius ? {
          overflow: "hidden"
        } : {}),
        children: /*#__PURE__*/_jsx(BlockIcon, {
          content: node.content,
          style: node.style
        })
      })
    });
  }
  if (node.type === "gallery") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread({}, p.style),
      children: /*#__PURE__*/_jsx("div", {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(".concat(node.content.columns || 3, ", 1fr)"),
          gap: resolveBlockGap(node.style, "12px")
        },
        children: (node.content.images || []).map(function (img, i) {
          return /*#__PURE__*/_jsx("img", {
            src: img.src,
            alt: img.alt || "",
            style: {
              width: "100%",
              aspectRatio: "1 / 1",
              height: "auto",
              objectFit: "cover",
              borderRadius: 8,
              display: "block"
            }
          }, i);
        })
      })
    }));
  }
  if (node.type === "cta") {
    var _node$style48, _node$style49, _node$style50;
    var ctaGap = resolveBlockGap(p.style, "12px");
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        gap: ctaGap,
        textAlign: ((_node$style48 = node.style) === null || _node$style48 === void 0 ? void 0 : _node$style48.textAlign) || "center",
        alignItems: ((_node$style49 = node.style) === null || _node$style49 === void 0 ? void 0 : _node$style49.textAlign) === "left" ? "flex-start" : ((_node$style50 = node.style) === null || _node$style50 === void 0 ? void 0 : _node$style50.textAlign) === "right" ? "flex-end" : "center",
        fontFamily: nodeFont
      }),
      children: [/*#__PURE__*/_jsx("h2", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "1.75rem"
        }, elStyle("title")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "title",
          value: node.content.title,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("title", v);
          },
          placeholder: "CTA Title"
        })
      }), /*#__PURE__*/_jsx("p", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          opacity: 0.85
        }, elStyle("subtitle")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "subtitle",
          value: node.content.subtitle,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("subtitle", v);
          },
          placeholder: "CTA Subtitle"
        })
      }), /*#__PURE__*/_jsx("span", {
        style: _objectSpread(_objectSpread({
          display: "inline-block",
          maxWidth: "100%",
          padding: "10px 24px",
          borderRadius: 20,
          background: "#ffffff",
          color: "#1e1b4b"
        }, elStyle("buttonText")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "buttonText",
          singleLine: true,
          value: node.content.buttonText,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("buttonText", v);
          },
          placeholder: "Button Text",
          style: {
            color: "#1e1b4b",
            textAlign: "center"
          }
        })
      })]
    }));
  }
  if (node.type === "logos") {
    var logosGap = resolveBlockGap(node.style, "24px");
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        gap: logosGap,
        textAlign: "center",
        alignItems: "center",
        fontFamily: nodeFont
      }),
      children: [node.content.title && /*#__PURE__*/_jsx("p", {
        style: _objectSpread({
          margin: 0,
          fontSize: 13,
          opacity: 0.7,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          fontFamily: nodeFont
        }, BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "title",
          value: node.content.title,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("title", v);
          },
          placeholder: "Section Title"
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: logosGap,
          width: "100%"
        },
        children: (node.content.logos || []).map(function (logo, i) {
          return /*#__PURE__*/_jsx("img", {
            src: logo.src,
            alt: logo.alt || "",
            style: {
              height: 36,
              maxWidth: 120,
              objectFit: "contain",
              opacity: 0.7
            }
          }, i);
        })
      })]
    }));
  }
  if (node.type === "accordion") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        gap: resolveBlockGap(p.style, "0px"),
        fontFamily: nodeFont
      }),
      children: (node.content.items || []).map(function (item, i) {
        return /*#__PURE__*/_jsxs("div", {
          style: {
            borderBottom: "1px solid #e2e8f0"
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: _objectSpread(_objectSpread({
              padding: "14px 0"
            }, elStyle("item_".concat(i, "_title"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "item_".concat(i, "_title"),
              value: item.title,
              onChange: function onChange(v) {
                if (typeof editAccordionItem === "function") editAccordionItem(i, "title", v);
              },
              placeholder: "Question Title"
            })
          }), (isNodeSelected || node.content.openIndex === i) && /*#__PURE__*/_jsx("div", {
            style: _objectSpread(_objectSpread({
              padding: "0 0 14px 0",
              opacity: 0.8,
              lineHeight: 1.6,
              whiteSpace: "pre-wrap"
            }, elStyle("item_".concat(i, "_body"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "item_".concat(i, "_body"),
              value: item.body,
              onChange: function onChange(v) {
                if (typeof editAccordionItem === "function") editAccordionItem(i, "body", v);
              },
              isTextArea: true,
              rows: 3,
              placeholder: "Answer details..."
            })
          })]
        }, i);
      })
    }));
  }
  if (node.type === "pricing") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        gap: resolveBlockGap(p.style, "16px"),
        flexWrap: "wrap",
        fontFamily: nodeFont
      }),
      children: (node.content.plans || []).map(function (plan, i) {
        return /*#__PURE__*/_jsxs("div", {
          style: {
            flex: "1 1 160px",
            minWidth: 0,
            padding: 20,
            borderRadius: 12,
            border: plan.highlighted ? "2px solid #101828" : "1px solid #e2e8f0",
            background: plan.highlighted ? "#f8fafc" : "#fff",
            textAlign: "center",
            fontFamily: nodeFont
          },
          children: [/*#__PURE__*/_jsx("h3", {
            style: _objectSpread(_objectSpread({
              margin: "0 0 8px 0",
              fontSize: "1rem"
            }, elStyle("plan_".concat(i, "_name"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "plan_".concat(i, "_name"),
              value: plan.name,
              onChange: function onChange(v) {
                if (typeof editPricingPlan === "function") editPricingPlan(i, "name", v);
              },
              placeholder: "Plan Name"
            })
          }), /*#__PURE__*/_jsxs("div", {
            style: _objectSpread(_objectSpread({
              fontSize: "1.75rem",
              margin: "8px 0"
            }, elStyle("plan_".concat(i, "_price"))), BLOCK_TEXT_WRAP_STYLE),
            children: [input({
              elementKey: "plan_".concat(i, "_price"),
              value: plan.price,
              onChange: function onChange(v) {
                if (typeof editPricingPlan === "function") editPricingPlan(i, "price", v);
              },
              placeholder: "$0",
              style: {
                display: "inline-block",
                width: "80px"
              }
            }), /*#__PURE__*/_jsx("span", {
              style: _objectSpread({
                fontSize: 13,
                fontWeight: 400
              }, elStyle("plan_".concat(i, "_period"))),
              children: input({
                elementKey: "plan_".concat(i, "_period"),
                value: plan.period,
                onChange: function onChange(v) {
                  if (typeof editPricingPlan === "function") editPricingPlan(i, "period", v);
                },
                placeholder: "/mo",
                style: {
                  display: "inline-block",
                  width: "50px"
                }
              })
            })]
          }), /*#__PURE__*/_jsx("ul", {
            style: {
              listStyle: "none",
              padding: 0,
              margin: "12px 0",
              textAlign: "left",
              fontFamily: nodeFont
            },
            children: (plan.features || []).map(function (f, fi) {
              return /*#__PURE__*/_jsxs("li", {
                style: _objectSpread(_objectSpread({
                  padding: "3px 0",
                  fontSize: 13
                }, elStyle("plan_".concat(i, "_feature_").concat(fi))), BLOCK_TEXT_WRAP_STYLE),
                children: ["\u2713", " ", input({
                  elementKey: "plan_".concat(i, "_feature_").concat(fi),
                  value: f,
                  onChange: function onChange(v) {
                    if (typeof editPricingFeature === "function") editPricingFeature(i, fi, v);
                  },
                  placeholder: "Feature...",
                  style: {
                    display: "inline-block",
                    width: "calc(100% - 20px)"
                  }
                })]
              }, fi);
            })
          }), /*#__PURE__*/_jsx("span", {
            style: _objectSpread(_objectSpread({
              display: "inline-block",
              maxWidth: "100%",
              padding: "6px 16px",
              borderRadius: 20,
              background: "#101828",
              color: "#fff",
              fontSize: 12
            }, elStyle("plan_".concat(i, "_buttonText"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "plan_".concat(i, "_buttonText"),
              variant: "onColor",
              singleLine: true,
              value: plan.buttonText,
              onChange: function onChange(v) {
                if (typeof editPricingPlan === "function") editPricingPlan(i, "buttonText", v);
              },
              placeholder: "Choose Plan",
              style: {
                color: "#fff",
                textAlign: "center"
              }
            })
          })]
        }, i);
      })
    }));
  }
  if (node.type === "testimonials") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: resolveBlockGap(p.style, "16px"),
        fontFamily: nodeFont
      }),
      children: (node.content.items || []).map(function (item, i) {
        return /*#__PURE__*/_jsxs("div", {
          style: _objectSpread({
            padding: 16,
            borderRadius: 12,
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            fontFamily: nodeFont,
            minWidth: 0
          }, BLOCK_TEXT_WRAP_STYLE),
          children: [/*#__PURE__*/_jsxs("p", {
            style: _objectSpread(_objectSpread({
              margin: "0 0 12px 0",
              fontStyle: isSingleWeightFont(nodeFont) ? "normal" : "italic",
              lineHeight: 1.6,
              fontSize: 14
            }, elStyle("item_".concat(i, "_quote"))), BLOCK_TEXT_WRAP_STYLE),
            children: ["\u201C", input({
              elementKey: "item_".concat(i, "_quote"),
              value: item.quote,
              onChange: function onChange(v) {
                if (typeof editTestimonial === "function") editTestimonial(i, "quote", v);
              },
              placeholder: "Quote text..."
            }), "\u201D"]
          }), /*#__PURE__*/_jsx("div", {
            style: _objectSpread(_objectSpread({
              fontSize: 13
            }, elStyle("item_".concat(i, "_name"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "item_".concat(i, "_name"),
              value: item.name,
              onChange: function onChange(v) {
                if (typeof editTestimonial === "function") editTestimonial(i, "name", v);
              },
              placeholder: "Name"
            })
          }), /*#__PURE__*/_jsx("div", {
            style: _objectSpread(_objectSpread({
              fontSize: 11,
              opacity: 0.7
            }, elStyle("item_".concat(i, "_role"))), BLOCK_TEXT_WRAP_STYLE),
            children: input({
              elementKey: "item_".concat(i, "_role"),
              value: item.role,
              onChange: function onChange(v) {
                if (typeof editTestimonial === "function") editTestimonial(i, "role", v);
              },
              placeholder: "Role"
            })
          })]
        }, i);
      })
    }));
  }
  if (node.type === "text-banner") {
    var _node$style51, _p$style10, _p$style11, _p$style12;
    var bannerGap = resolveBlockGap(p.style, "8px");
    var bannerAlign = ((_node$style51 = node.style) === null || _node$style51 === void 0 ? void 0 : _node$style51.textAlign) || "center";
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        alignItems: bannerAlign === "left" ? "flex-start" : bannerAlign === "right" ? "flex-end" : "center",
        justifyContent: "center",
        gap: bannerGap,
        textAlign: bannerAlign
      }, styleHasSpacing(p.style, "padding") ? {} : {
        padding: "32px 28px"
      }), ((_p$style10 = p.style) === null || _p$style10 === void 0 ? void 0 : _p$style10.borderRadius) != null && p.style.borderRadius !== "" || hasIndividualRadius(p.style) ? {} : {
        borderRadius: 12
      }), (_p$style11 = p.style) !== null && _p$style11 !== void 0 && _p$style11.background || (_p$style12 = p.style) !== null && _p$style12 !== void 0 && _p$style12.backgroundColor ? {} : {
        background: "#f1f5f9"
      }), {}, {
        fontFamily: nodeFont
      }),
      children: [/*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "1.125rem",
          fontWeight: 700,
          color: "#0f172a"
        }, elStyle("title")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "title",
          value: node.content.title,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("title", v);
          },
          placeholder: "Banner title..."
        })
      }), /*#__PURE__*/_jsx("div", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: 14,
          fontWeight: 400,
          color: "#64748b"
        }, elStyle("text")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "text",
          value: node.content.text,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("text", v);
          },
          placeholder: "Banner message..."
        })
      }), node.content.linkText && /*#__PURE__*/_jsxs("span", {
        style: _objectSpread(_objectSpread({
          textDecoration: "underline",
          fontSize: 14
        }, elStyle("linkText")), BLOCK_TEXT_WRAP_STYLE),
        children: [input({
          elementKey: "linkText",
          value: node.content.linkText,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("linkText", v);
          },
          placeholder: "Link text...",
          style: {
            display: "inline-block",
            width: "auto",
            minWidth: "100px",
            textDecoration: "underline"
          }
        }), " ", "\u2192"]
      })]
    }));
  }
  if (node.type === "cover") {
    var _p$style13;
    var coverGap = resolveBlockGap(p.style, "12px");
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, p.style), {}, {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: coverGap
      }, styleHasSpacing(p.style, "padding") ? {} : {
        padding: "50px 30px"
      }), ((_p$style13 = p.style) === null || _p$style13 === void 0 ? void 0 : _p$style13.borderRadius) != null && p.style.borderRadius !== "" || hasIndividualRadius(p.style) ? {} : {
        borderRadius: 12
      }), {}, {
        textAlign: "left",
        fontFamily: nodeFont
      }),
      children: [innerBorderOverlay, /*#__PURE__*/_jsx("h1", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "2rem"
        }, elStyle("title")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "title",
          value: node.content.title,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("title", v);
          },
          placeholder: "Proposal Title"
        })
      }), /*#__PURE__*/_jsx("h3", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: "1.2rem",
          fontWeight: "normal",
          opacity: 0.9
        }, elStyle("subtitle")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "subtitle",
          value: node.content.subtitle,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("subtitle", v);
          },
          placeholder: "Proposal Subtitle"
        })
      }), /*#__PURE__*/_jsx("p", {
        style: _objectSpread(_objectSpread({
          margin: 0,
          fontSize: 14,
          opacity: 0.8,
          lineHeight: 1.6,
          whiteSpace: "pre-wrap"
        }, elStyle("description")), BLOCK_TEXT_WRAP_STYLE),
        children: input({
          elementKey: "description",
          value: node.content.description,
          onChange: function onChange(v) {
            if (typeof editContentField === "function") editContentField("description", v);
          },
          isTextArea: true,
          rows: 3,
          placeholder: "Cover description..."
        })
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          borderTop: "1px solid rgba(255,255,255,0.2)",
          paddingTop: 15,
          fontSize: 12,
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10
        },
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              opacity: 0.7
            },
            children: "Prepared By:"
          }), " ", /*#__PURE__*/_jsx("strong", {
            style: _objectSpread({}, elStyle("author")),
            children: input({
              elementKey: "author",
              value: node.content.author,
              onChange: function onChange(v) {
                if (typeof editContentField === "function") editContentField("author", v);
              },
              placeholder: "Author",
              style: {
                display: "inline-block",
                width: "auto",
                minWidth: 80
              }
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("span", {
            style: {
              opacity: 0.7
            },
            children: "Date:"
          }), " ", /*#__PURE__*/_jsx("strong", {
            style: _objectSpread({}, elStyle("date")),
            children: input({
              elementKey: "date",
              value: node.content.date,
              onChange: function onChange(v) {
                if (typeof editContentField === "function") editContentField("date", v);
              },
              placeholder: "Date",
              style: {
                display: "inline-block",
                width: "auto",
                minWidth: 80
              }
            })
          })]
        })]
      })]
    }));
  }
  if (node.type === "signature") {
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        gap: resolveBlockGap(p.style, "20px"),
        fontFamily: nodeFont
      }),
      children: [{
        side: "client",
        label: "Client Representative",
        name: node.content.clientName,
        title: node.content.clientTitle,
        date: node.content.clientDate,
        signed: node.content.clientSigned,
        signature: node.content.clientSignature
      }, {
        side: "provider",
        label: "Provider Representative",
        name: node.content.providerName,
        title: node.content.providerTitle,
        date: node.content.providerDate,
        signed: node.content.providerSigned,
        signature: node.content.providerSignature
      }].map(function (block) {
        var _node$style52, _node$style53;
        return /*#__PURE__*/_jsxs("div", {
          style: {
            padding: 20,
            borderRadius: 8,
            border: "1px solid #e2e8f0",
            background: "#fff",
            color: ((_node$style52 = node.style) === null || _node$style52 === void 0 ? void 0 : _node$style52.color) || "#334155",
            minWidth: 0
          },
          children: [/*#__PURE__*/_jsx("div", {
            style: {
              fontSize: 11,
              fontWeight: "bold",
              textTransform: "uppercase",
              color: "#6b7280",
              marginBottom: 12
            },
            children: block.label
          }), block.signed ? (block.signature || "").trim() ? /*#__PURE__*/_jsx("div", {
            style: _objectSpread({
              fontFamily: "'Great Vibes', 'Pacifico', 'Dancing Script', cursive",
              fontSize: 28,
              color: ((_node$style53 = node.style) === null || _node$style53 === void 0 ? void 0 : _node$style53.color) || "#4f46e5",
              borderBottom: "2px solid #e2e8f0",
              padding: "10px 0",
              marginBottom: 10
            }, BLOCK_TEXT_WRAP_STYLE),
            children: block.signature
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              height: 50,
              borderBottom: "2px solid #e2e8f0",
              marginBottom: 10,
              display: "flex",
              alignItems: "center",
              color: "#6b7280",
              fontSize: 11,
              fontStyle: "italic"
            },
            children: "Add signature text in right panel \u2192"
          }) : /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: function onClick(e) {
              e.stopPropagation();
              signBlockSide(node.id, block.side);
            },
            style: {
              width: "100%",
              height: 50,
              border: "2px dashed #cbd5e1",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#6b7280",
              fontSize: 13,
              cursor: "pointer",
              marginBottom: 10,
              background: "#f8fafc"
            },
            children: "Click to Sign"
          }), /*#__PURE__*/_jsx("div", {
            style: _objectSpread({
              fontWeight: nodeWeight,
              fontSize: 14,
              color: "inherit"
            }, BLOCK_TEXT_WRAP_STYLE),
            children: input({
              value: block.name,
              onChange: function onChange(v) {
                if (typeof editContentField === "function") editContentField("".concat(block.side, "Name"), v);
              },
              placeholder: "Name"
            })
          }), /*#__PURE__*/_jsx("div", {
            style: _objectSpread({
              fontSize: 12,
              opacity: 0.75,
              color: "inherit"
            }, BLOCK_TEXT_WRAP_STYLE),
            children: input({
              value: block.title,
              onChange: function onChange(v) {
                if (typeof editContentField === "function") editContentField("".concat(block.side, "Title"), v);
              },
              placeholder: "Title"
            })
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              fontSize: 11,
              opacity: 0.65,
              color: "inherit",
              marginTop: 4
            },
            children: ["Date:", " ", input({
              value: block.date,
              onChange: function onChange(v) {
                if (typeof editContentField === "function") editContentField("".concat(block.side, "Date"), v);
              },
              placeholder: "Date",
              style: {
                display: "inline-block",
                width: "auto",
                minWidth: "80px"
              }
            })]
          })]
        }, block.side);
      })
    }));
  }
  if (node.type === "timeline") {
    var _node$content3, _node$content4, _node$content5, _node$content6;
    var timelineStyle = ((_node$content3 = node.content) === null || _node$content3 === void 0 ? void 0 : _node$content3.timelineStyle) || "numbered-circle";
    var accentColor = ((_node$content4 = node.content) === null || _node$content4 === void 0 ? void 0 : _node$content4.accentColor) || (timelineStyle === "classic-dot" ? "#101828" : "#c8a896");
    var showDate = ((_node$content5 = node.content) === null || _node$content5 === void 0 ? void 0 : _node$content5.showDate) !== undefined ? !!node.content.showDate : timelineStyle === "classic-dot";
    var _isCircle = timelineStyle === "numbered-circle";
    var isStep = timelineStyle === "numbered-step";
    var items = ((_node$content6 = node.content) === null || _node$content6 === void 0 ? void 0 : _node$content6.items) || [];
    return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, p), {}, {
      style: _objectSpread(_objectSpread({}, p.style), {}, {
        display: "flex",
        flexDirection: "column",
        gap: 0,
        fontFamily: nodeFont
      }),
      children: items.map(function (item, i) {
        var _node$content7, _node$style54, _node$style55, _node$style56, _node$style57;
        var isLast = i === items.length - 1;
        var markerEl = null;
        var paddingTop = 0;
        var paddingBottom = isLast ? 4 : 28;
        var showNumbers = ((_node$content7 = node.content) === null || _node$content7 === void 0 ? void 0 : _node$content7.showNumber) !== false;
        var isNumCleared = item.number === "";
        var defaultStepNum = String(i + 1).padStart(2, "0");
        var defaultCircleNum = String(i + 1);
        var stepNumVal = item.number !== undefined ? item.number : defaultStepNum;
        var circleNumVal = item.number !== undefined ? item.number : defaultCircleNum;
        var shouldShowStepNum = showNumbers && !isNumCleared && Boolean(stepNumVal);
        var shouldShowCircleNum = showNumbers && !isNumCleared && Boolean(circleNumVal);
        if (_isCircle) {
          paddingTop = 4;
          markerEl = /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flexShrink: 0,
              width: 32
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: _objectSpread({
                width: 32,
                height: 32,
                minWidth: 32,
                minHeight: 32,
                maxWidth: 32,
                maxHeight: 32,
                borderRadius: "50%",
                border: "2px solid ".concat(accentColor),
                background: "#ffffff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: accentColor,
                fontSize: 13,
                fontWeight: 600,
                flexShrink: 0,
                boxSizing: "border-box",
                lineHeight: 1,
                margin: 0,
                overflow: "hidden"
              }, elStyle("item_".concat(i, "_number"))),
              children: shouldShowCircleNum && input({
                elementKey: "item_".concat(i, "_number"),
                singleLine: true,
                value: circleNumVal,
                onChange: function onChange(v) {
                  if (typeof editTimelineItem === "function") editTimelineItem(i, "number", v);
                },
                placeholder: defaultCircleNum,
                style: {
                  color: "inherit",
                  fontWeight: "inherit",
                  fontSize: "inherit",
                  display: "inline-block",
                  width: "26px",
                  minWidth: 0,
                  minHeight: 0,
                  height: "100%",
                  textAlign: "center",
                  border: "none",
                  background: "transparent",
                  lineHeight: 1,
                  overflow: "hidden"
                }
              })
            }), !isLast && /*#__PURE__*/_jsx("div", {
              style: {
                width: 2,
                flex: 1,
                minHeight: 28,
                background: accentColor,
                margin: 0
              }
            })]
          });
        } else if (isStep) {
          paddingTop = 0;
          markerEl = /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flexShrink: 0,
              width: 20
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                width: 16,
                height: 16,
                borderRadius: "50%",
                border: "2px solid ".concat(accentColor),
                background: "#ffffff",
                flexShrink: 0,
                boxSizing: "border-box",
                margin: 0
              }
            }), !isLast && /*#__PURE__*/_jsx("div", {
              style: {
                width: 2,
                flex: 1,
                minHeight: 28,
                background: accentColor,
                margin: 0
              }
            })]
          });
        } else {
          paddingTop = 0;
          paddingBottom = isLast ? 4 : 20;
          markerEl = /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flexShrink: 0,
              width: 16
            },
            children: [/*#__PURE__*/_jsx("div", {
              style: {
                width: 14,
                height: 14,
                borderRadius: "50%",
                background: accentColor,
                border: "2px solid ".concat(accentColor),
                flexShrink: 0,
                boxSizing: "border-box",
                margin: 0
              }
            }), !isLast && /*#__PURE__*/_jsx("div", {
              style: {
                width: 2,
                flex: 1,
                minHeight: 24,
                background: accentColor,
                margin: 0
              }
            })]
          });
        }
        return /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            gap: _isCircle ? 20 : 16,
            minWidth: 0,
            margin: 0,
            padding: 0
          },
          children: [markerEl, /*#__PURE__*/_jsxs("div", {
            style: {
              flex: 1,
              minWidth: 0,
              paddingTop: paddingTop,
              paddingBottom: paddingBottom
            },
            children: [/*#__PURE__*/_jsxs("div", {
              style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                flexWrap: "wrap",
                gap: 8
              },
              children: [/*#__PURE__*/_jsxs("div", {
                style: {
                  display: "flex",
                  alignItems: "baseline",
                  flex: 1,
                  minWidth: 0
                },
                children: [isStep && shouldShowStepNum && /*#__PURE__*/_jsx("span", {
                  style: _objectSpread({
                    color: accentColor,
                    fontWeight: 600,
                    fontSize: 13,
                    letterSpacing: "0.5px",
                    marginRight: 8,
                    flexShrink: 0,
                    display: "inline-flex",
                    alignItems: "center"
                  }, elStyle("item_".concat(i, "_number"))),
                  children: input({
                    elementKey: "item_".concat(i, "_number"),
                    singleLine: true,
                    value: stepNumVal,
                    onChange: function onChange(v) {
                      if (typeof editTimelineItem === "function") editTimelineItem(i, "number", v);
                    },
                    placeholder: defaultStepNum,
                    style: {
                      color: "inherit",
                      fontWeight: "inherit",
                      fontSize: "inherit",
                      display: "inline-block",
                      width: "32px",
                      textAlign: "left",
                      border: "none",
                      background: "transparent"
                    }
                  })
                }), /*#__PURE__*/_jsx("h4", {
                  style: _objectSpread(_objectSpread({
                    margin: 0,
                    fontSize: isStep ? 15 : 14,
                    fontWeight: 600,
                    color: ((_node$style54 = node.style) === null || _node$style54 === void 0 ? void 0 : _node$style54.color) || "#1e293b",
                    letterSpacing: _isCircle ? "0.5px" : "normal",
                    textTransform: _isCircle ? "uppercase" : "none",
                    flex: 1,
                    minWidth: 0
                  }, elStyle("item_".concat(i, "_title"))), BLOCK_TEXT_WRAP_STYLE),
                  children: input({
                    elementKey: "item_".concat(i, "_title"),
                    value: item.title,
                    onChange: function onChange(v) {
                      if (typeof editTimelineItem === "function") editTimelineItem(i, "title", v);
                    },
                    placeholder: isStep ? "Step Title" : "Milestone Title"
                  })
                })]
              }), showDate && /*#__PURE__*/_jsx("span", {
                style: _objectSpread({
                  fontSize: 12,
                  fontWeight: "bold",
                  color: ((_node$style55 = node.style) === null || _node$style55 === void 0 ? void 0 : _node$style55.color) || "#101828"
                }, elStyle("item_".concat(i, "_date"))),
                children: input({
                  elementKey: "item_".concat(i, "_date"),
                  value: item.date,
                  onChange: function onChange(v) {
                    if (typeof editTimelineItem === "function") editTimelineItem(i, "date", v);
                  },
                  placeholder: "Date",
                  style: {
                    fontWeight: "bold",
                    color: "inherit",
                    display: "inline-block",
                    width: "80px",
                    textAlign: "right"
                  }
                })
              })]
            }), /*#__PURE__*/_jsx("p", {
              style: _objectSpread(_objectSpread({
                margin: "6px 0 0 0",
                fontSize: 13,
                color: ((_node$style56 = node.style) === null || _node$style56 === void 0 ? void 0 : _node$style56.color) || "#475569",
                lineHeight: 1.6,
                whiteSpace: "pre-wrap",
                opacity: (_node$style57 = node.style) !== null && _node$style57 !== void 0 && _node$style57.color ? 0.85 : 1
              }, elStyle("item_".concat(i, "_description"))), BLOCK_TEXT_WRAP_STYLE),
              children: input({
                elementKey: "item_".concat(i, "_description"),
                value: item.description,
                onChange: function onChange(v) {
                  if (typeof editTimelineItem === "function") editTimelineItem(i, "description", v);
                },
                isTextArea: true,
                rows: 2,
                placeholder: "Step description details..."
              })
            })]
          })]
        }, i);
      })
    }));
  }
  return null;
}